export default __webpack_public_path__ + "static/media/2b001.9ed84ceb.png";